var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error,idx){return _c('span',{key:'error_npw_' + idx,staticClass:"form-error"},[_vm._v(" "+_vm._s(error)),_c('br')])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }